import type { VehicleIncentive } from '../../../types/vehicleIncentive';

const nonCapitalizedInLease = (incentives: VehicleIncentive[]) => {
  let incentivesArray = incentives || [];

  return incentivesArray.reduce((acc, incentive) => {
    let incentiveAmount =
      incentive &&
      incentive.evaluation &&
      incentive.evaluation.applicableToLease &&
      !incentive.evaluation.capitalizedInLease &&
      !isNaN(incentive.evaluation.amountInLease)
        ? incentive.evaluation.amountInLease
        : 0;

    return acc + incentiveAmount;
  }, 0);
};

export default nonCapitalizedInLease;
